import AppData from './AppData'
import network from '../common/network'
import logger from '../common/logger'
// import history from '../history'
import AppAnalytics from './AppAnalytics'
import uuid from 'uuid'
import axios from 'axios'
import _ from 'underscore'
import MCOSuccessClip from '../assets/mco_success.mp3'

let timer = AppData.topicRefreshPeriod

// Audio notification state for order confirmation sounds
let audioUnlocked = false           
let isPlayingNotification = false    
let pendingNotificationCount = 0     
let lastNotificationEnqueueTime = 0
let userInteractionListenersAdded = false
let globalAudioContext = null

// Track when each order ID was added to ignored list (for cleanup)
let ignoredSoundTimestamps = {}

// Cleanup old ignored sound IDs (older than 1 hour) - called on-demand
function cleanupOldIgnoredSounds(AppData) {
    const oneHourAgo = Date.now() - (60 * 60 * 1000) // 1 hour in milliseconds
    
    // Filter out order IDs older than 1 hour
    const validOrderIds = AppData.ignoredSoundIds.filter(orderId => {
        const timestamp = ignoredSoundTimestamps[orderId]
        return timestamp && timestamp > oneHourAgo
    })
    
    // Update the ignored list only if something changed
    if (validOrderIds.length !== AppData.ignoredSoundIds.length) {
        AppData.ignoredSoundIds = validOrderIds
        
        // Clean up timestamp tracking for removed IDs
        Object.keys(ignoredSoundTimestamps).forEach(orderId => {
            if (!validOrderIds.includes(orderId)) {
                delete ignoredSoundTimestamps[orderId]
            }
        })
    }
}  

export const checkLandscape = () => {
    return (window.innerWidth > 361)? 'Landscape' : 'Portrait' 
}


export const delay = ms => {
    return new Promise(response => setTimeout(response, ms))
}

export const navbarConfirmedObject = data => {
    let newItem = []
    let lastItem = null
    data.items.forEach(item => {
        if((item.product_id && item.name && item.price) !== undefined){
            if (item.price < 0 ||  item.ProductType === 62 || item.ProductType === 53 || item.ProductType === 54) {
                if (lastItem) {
                    let vmItemDeal = {}
                    vmItemDeal.Description = item.name
                    vmItemDeal.SubTotal = item.price * item.quantity
                    vmItemDeal.ProductType = item.ProductType ? item.ProductType : ''
                    lastItem.deals.push(vmItemDeal)
                }
                return 
            }
            let vmItem = {}
            vmItem.deals = []
            vmItem.product = {
                name: item.name,
                price: item.price,
                product_id: item.product_id
            }
            vmItem.quantity = item.quantity
            vmItem.deposit_amount = item.deposit_amount
            lastItem = vmItem
            newItem.push(vmItem)
            return null
        }
    })
    return {
        arbitrationToken : data.arbitrationToken,
        customer_id: undefined,
        grandTotal: data.total,
        isOrderConfirmed: AppData.isStoreShowAndGo() ? true : data.is_order_confirmed,
        itemType: 'order',
        items: newItem,
        orderStatus: data.order_status,
        order_id: data.order_id,
        transaction_icon: true,
        transaction_status: false,
        showAndGoIconCheck: AppData.isStoreShowAndGo() ? true : false,
        updated_time: data.created,
        user_profile: data.user_profile,
        _id: data._id
    }
}

export const cartModal = carts => {
    let viewModels = []
    if (carts === undefined || carts.length < 1) {
        return viewModels
    }
    carts.map(cart => {
        let vm = {}
        if (cart.user_profile) {
            let user_profile =  cart.user_profile 
            if (user_profile) {
                vm.user_profile = {
                    first_name: _.isArray(user_profile) ? _.first(user_profile.first_name) : user_profile.first_name,
                    last_name: _.isArray(user_profile) ? _.first(user_profile.last_name) : user_profile.last_name,
                    email: _.isArray(user_profile) ? _.first(user_profile.email) : user_profile.email,
                    loyalty_id: _.isArray(user_profile) ? _.first(user_profile.loyalty_id) : user_profile.loyalty_id
                }
            }
        }
        vm._id = cart._id
        vm.customer_id = cart.customer_id
        vm.grandTotal = cart.grandTotal
        vm.updated_time = cart.updated_time
        vm.arbitrationToken = cart.arbitrationToken
        vm.items = []
        vm.itemType = cart.itemType
        vm.cartWithDeals = cart.cartWithDeals
        cart.items.map(item => {
            let vmItem = {}
            vmItem.product_description = item.product_description 
            vmItem.deals = []
            if (item.deals && item.deals.length > 0) {
                item.deals.map(deal => {
                    let vmItemDeal = {}
                    vmItemDeal.Description = deal.Description
                    vmItemDeal.SubTotal = deal.SubTotal
                    vmItem.deals.push(vmItemDeal)
                    return null
                })
            }
            vmItem.product = (item.product !== undefined) ? {
                name: item.product.name ? item.product.name : item.product_name,
                price: item.product.price ? item.product.price : item.price,
                product_id: item.product_id ? item.product_id : item.product.product_id
            }:{
                name: item.product_id,
                price: 0,
                product_id: item.product_id
            }
            vmItem.eco = []
            if (item.eco && item.eco.length > 0) {
                item.eco.map(deal => {
                    let vmItemDeal = {}
                    vmItemDeal.Description = deal.Description
                    vmItemDeal.Total = deal.Total
                    vmItemDeal.ProductType = deal.ProductType
                    vmItem.eco.push(vmItemDeal)
                    return null
                })
            }
            vmItem.deposit = []
            if (item.deposit && item.deposit.length > 0) {
                item.deposit.map(deal => {
                    let vmItemDeal = {}
                    vmItemDeal.Description = deal.Description
                    vmItemDeal.Total = deal.Total
                    vmItemDeal.ProductType = deal.ProductType
                    vmItem.deposit.push(vmItemDeal)
                    return null            
                })
            }
            vmItem.quantity = item.quantity
            if (item.product !== undefined){
                vm.items.push(vmItem)
            }
            return null
        })
        viewModels.push(vm)
        return null
    })
    return viewModels
}

/**
 * Mapping products details with cart details using productId
 * @param {*} cartDetails 
 * @param {*} productsData 
 */
export const getCartWithDeals = (cartDetails , productsData) => {
    cartDetails.map(cart => { 
        cart.itemType = 'cart'
        let cartWithDealsMap = {}
        let mapItemProducts = {}
        cart.cartWithDeals.forEach(cartWithDeal => {
            cartWithDealsMap[cartWithDeal.Suiid] = cartWithDeal
        })

        if(productsData === null || productsData.length === 0){
            cart.items.reverse().map(item => {
                mapItemProducts = {
                    ...mapItemProducts,

                    age_restricted : item.age_restricted,
                    age_restriction : item.age_restriction, 
                    name : item.name,
                    price : item.price,
                    suiid : item.suiid,
                    thumbnail : item.thumbnail,
                    quantity : item.quantity
                } 
                item.product = mapItemProducts
                if ('suiid' in item) {
                    let deals = (cartWithDealsMap[mapItemProducts['suiid']] === undefined) ? null :cartWithDealsMap[mapItemProducts.suiid].Deals
                    let deposit = (cartWithDealsMap[mapItemProducts['suiid']] === undefined) ? null :cartWithDealsMap[mapItemProducts.suiid].Deposit
                    let eco = (cartWithDealsMap[mapItemProducts['suiid']] === undefined) ? null :cartWithDealsMap[mapItemProducts.suiid].Eco
                    item.deals = deals
                    item.deposit = deposit
                    item.eco = eco
                }
                return null
            }) 
        }else{
            let productIdMap = {}
            productsData.map(product => (product && product.product_id !== undefined) ? productIdMap[product.product_id] = product: null)
    
            cart.items.reverse().map(item => {
                let product = productIdMap[item.product_id]
                item.product = product

                if (product && 'suiid' in product) {
                    let deals = (cartWithDealsMap[product['suiid']] === undefined) ? null :cartWithDealsMap[product.suiid].Deals
                    let deposit = (cartWithDealsMap[product['suiid']] === undefined) ? null :cartWithDealsMap[product.suiid].Deposit
                    let eco = (cartWithDealsMap[product['suiid']] === undefined) ? null :cartWithDealsMap[product.suiid].Eco
                    item.deals = deals
                    item.deposit = deposit
                    item.eco = eco
                }
                return null
            }) 
        }
        return null
    })

    cartDetails = cartDetails.reverse()
    return cartDetails
}
/**
 * Convert time in format : HH:MM AM/PM
 * @param {*} currentDateTime 
 */
export const getUpdatedTime = reportDate => {

    let currentDate = ''
    if(reportDate.length > 0){
        currentDate = new Date(reportDate)
    }
    let dayWithDate = `${currentDate.toDateString().split(' ')[0]}, ${currentDate.getMonth() + 1}/${currentDate.getDate()}, `
    currentDate = currentDate.toLocaleTimeString()
    let timeFormat = currentDate.split(':').slice(0, 2).join(':') + currentDate.split(':').slice(2).join(' ').split(' ').pop()
    let updateTime = dayWithDate + timeFormat.toLowerCase()
    return updateTime
}


export const topicConnection = data => {
    logger.info('NA', 'pubsub fetch', 'pubsub_subscribe', 'NA', 'Topic Connected/disconnected', data)
    AppData.isError = true
    AppData.errorMessage = 'NO_INTERNET_ACCESS'
    AppAnalytics.trackReloading('MQTT reconnection from topicConnection')

    // Instead of reloading, trigger MQTT reconnection when online
    if(navigator.onLine === true && AppData.isError === true){
        setTimeout(() => {
            AppAnalytics.trackReloading('MQTT reconnection from topicConnection')
            // Trigger MQTT reconnection instead of page reload
            if (window.handleIoTReconnection) {
                window.handleIoTReconnection()
            }
        }, timer)
    }
}

export const getTokenCall = (completionHandler , errorHandler) => {
    let config = {}
    let deviceProfileText = (window.Android && window.Android.getDeviceProfile) ? window.Android.getDeviceProfile() : ''
    logger.info('NA', 'fetch device profile in home', 'fetchStoreId', 'NA', 'success', deviceProfileText + '')
    let storeId = localStorage.getItem('storeId')  
    let Uuid = uuid.v4()
    let configData = {
        'store_id' : storeId,
        'uuid' : Uuid
    }
    network.getJWTToken(
        configData,
        res=>{
            const deviceId = JSON.parse(localStorage.getItem('lvt.config')).deviceId
            const deviceType = JSON.parse(localStorage.getItem('lvt.config')).deviceType
            localStorage.removeItem('lvt.config')
            const response = res
            config = Object.assign(config,  {'deviceId': deviceId , 'deviceType': deviceType, 'storeId' : storeId, 'jwt' : response.data.jwt_token , systemIdentifier: Uuid  , setupComplete : true})
            localStorage.setItem('lvt.config', JSON.stringify(config))
            //   let newLvtConfig = JSON.parse( localStorage.getItem( 'lvt.config' ) )
            completionHandler()
        }, 
        error=>{
            logger.error('NA', 'JWT token fetch', 'get_JWTtoken', 'NA', 'JWT token fetch', error)
            // TODO: Once successfull implementation of login uncomment below line.
            // config.setSetupComplete( false )
            // history.push( '/' )
            errorHandler(error)
        }
    ) 
}

export const historyCount = async () => {
    let currentDate = new Date()
    let yesterdayDate = new Date(new Date().setDate(new Date().getDate() - AppData.previousOrderPerDays)) 
    let query = {
        'created' : { $lt: currentDate , $gte: yesterdayDate}
    }
    network.getOrdersConfirmed(
        response=>{
            let ordersData = response && response.data ? response.data : []   
            // eslint-disable-next-line no-unused-vars
            let ordersDataCount = ordersData && ordersData.orders ? ordersData.orders : []
            ordersDataCount = ordersDataCount.filter(order=>{
                if(this.getUnwantedName(order.user_profile.first_name)){
                    return false
                }
                if(order.order_status === 'selfcheckedout'){
                    return true
                } 
                return null
            }).length      
        },
        error=>{
            console.log(error)
        },
        query
    )
}

export const setHeader =  originalRequest => {
    return new Promise((resolve, reject) => {
        getTokenCall(() => { 
            const newToken = JSON.parse(localStorage.getItem('lvt.config')).jwt
            let headers = {
                'Content-Type': 'application/json',
                'x-api-key':process.env.REACT_APP_API_KEY ,
            }
            const header = {
                ...headers, Authorization: `Bearer ${newToken}`,
            }
            axios.defaults.headers = header
            originalRequest.headers = header
            return axios(originalRequest)
        } ,
        error => {
            reject(error)
        }) 
    })       
}

export const getCurrentStoreId =  () => {
    return localStorage.getItem('storeId')
}

// Handles the actual audio unlocking process
function performAudioUnlock() {
    if (audioUnlocked) return
    

    // iPad Safari specific detection
    const isIPadSafari = /iPad|iPhone|iPod/.test(navigator.userAgent) && /Safari/.test(navigator.userAgent)
    
    // Creating and resume AudioContext immediately
    try {
        const AudioContext = window.AudioContext || window.webkitAudioContext


        if (AudioContext) {
            if (!globalAudioContext) {
                globalAudioContext = new AudioContext()
            }
            
            // Force resume the audio context - more aggressive for iPad
            console.log('LVTIPAD:performAudioUnlock Within AudioContext', globalAudioContext.state);
            if (globalAudioContext.state === 'suspended') {
                globalAudioContext.resume().then(() => {
                    console.log('AudioContext resumed successfully')
                    audioUnlocked = true
                }).catch(error => {
                    console.log('AudioContext resume failed:', error)
                    audioUnlocked = false // Fallback
                })
            } else {
                audioUnlocked = false
            }
        }
    } catch (e) {
        console.log('AudioContext creation failed:', e)
        // Continue with audio element approach
    }

    // No audio playback on page load - only unlock through user interaction
    console.log('Audio unlock will happen on user interaction')
    // Don't play any audio on page load, rely on user interaction listeners only
}

// Remove user interaction listeners once audio is unlocked
function removeUserInteractionListeners() {
    if (!userInteractionListenersAdded) return
    
    const events = ['click', 'touchstart', 'touchend', 'mousedown', 'keydown']
    events.forEach(event => {
        document.removeEventListener(event, performAudioUnlock, { capture: true, passive: true })
    })
    userInteractionListenersAdded = false
}

// Sets up user interaction listeners to unlock audio on first interaction
export function unlockAudio() {
    console.log('LVTIPAD:unlockAudio() - audioUnlocked', audioUnlocked, '/audioEnabled: ', localStorage.getItem('audioEnabled'));
    if (audioUnlocked) return
    
    // Check if this is being called from the overlay (user interaction guaranteed)
    const audioEnabled = localStorage.getItem('audioEnabled')
    if (audioEnabled === 'true') {
        // User has explicitly enabled audio via overlay, perform immediate unlock
        performAudioUnlock()
        return
    }
    
    // If not from overlay, set up listeners as before but less aggressive
    if (userInteractionListenersAdded) return
    
    // Try immediate unlock first
    performAudioUnlock()
    
    // Set up passive listeners as fallback
    const events = ['click', 'touchstart', 'touchend', 'mousedown', 'keydown']
    events.forEach(event => {
        document.addEventListener(event, performAudioUnlock, { capture: true, passive: true, once: false })
    })
    userInteractionListenersAdded = true
}

// Try Web Audio API approach which sometimes bypasses autoplay restrictions
function tryWebAudioUnlock() {
    try {
        const AudioContext = window.AudioContext || window.webkitAudioContext
        if (AudioContext) {
            if (!globalAudioContext) {
                globalAudioContext = new AudioContext()
            }
            
            // Create a silent buffer and try to play it
            const buffer = globalAudioContext.createBuffer(1, 1, 22050)
            const source = globalAudioContext.createBufferSource()
            source.buffer = buffer
            source.connect(globalAudioContext.destination)
            source.start(0)
            
            if (globalAudioContext.state !== 'suspended') {
                audioUnlocked = true
                return true
            }
        }
    } catch (e) {
        // Continue with other methods
    }
    return false
}

// Attempt periodic unlock (aggressive approach)
function attemptPeriodicUnlock() {
    if (audioUnlocked) return
    
    let attempts = 0
    const maxAttempts = 10
    
    const periodicUnlock = setInterval(() => {
        attempts++
        
        if (audioUnlocked || attempts >= maxAttempts) {
            clearInterval(periodicUnlock)
            return
        }
        
        // Try different approaches each time
        if (attempts % 2 === 0) {
            tryWebAudioUnlock()
        } else {
            performAudioUnlock()
        }
    }, 1000) // Try every second
}

// Ensure AudioContext is active before playing audio (critical for mobile browsers)
function ensureAudioContextActive() {
    const isIPadSafari = /iPad|iPhone|iPod/.test(navigator.userAgent) && /Safari/.test(navigator.userAgent)
    
    if (globalAudioContext && globalAudioContext.state === 'suspended') {
        console.log('Resuming suspended AudioContext...')
        return globalAudioContext.resume().then(() => {
            console.log('AudioContext resumed for playback')
            return Promise.resolve()
        }).catch(error => {
            console.log('Failed to resume AudioContext:', error)
            // For iPad Safari, try creating a new context
            if (isIPadSafari) {
                try {
                    const AudioContext = window.AudioContext || window.webkitAudioContext
                    globalAudioContext = new AudioContext()
                    console.log('Created new AudioContext for iPad Safari')
                } catch (e) {
                    console.log('Failed to create new AudioContext:', e)
                }
            }
            return Promise.resolve()
        })
    }
    return Promise.resolve()
}

// Plays the next notification sound and chains the rest using a simple counter.
function playNextNotification() {
    if (pendingNotificationCount <= 0) {
        isPlayingNotification = false
        // Reset playing state when all sounds are done
        AppData.isPlaying = false
        AppData.playingOrderId = ''
        return
    }

    isPlayingNotification = true
    pendingNotificationCount -= 1

    const isIPadSafari = /iPad|iPhone|iPod/.test(navigator.userAgent) && /Safari/.test(navigator.userAgent)

    // Ensure AudioContext is active before playing (mobile browser fix)
    ensureAudioContextActive().then(() => {
        const audio = new Audio(MCOSuccessClip)
        let hasCompleted = false
        
        // Standard volume for all browsers - notifications should be audible
        audio.preload = 'auto'
        audio.volume = 0.7

        const onComplete = () => {
            if (hasCompleted) return
            hasCompleted = true
            playNextNotification()
        }

        // Fallback timeout in case playback stalls or "ended" is not fired.
        const playbackTimeout = setTimeout(() => {
            console.log('Audio playback timeout reached')
            onComplete()
        }, 10000)

        audio.addEventListener('ended', () => {
            console.log('Audio playback ended normally')
            clearTimeout(playbackTimeout)
            onComplete()
        }, { once: true })

        audio.addEventListener('error', e => {
            console.log('Audio playback error:', e)
            clearTimeout(playbackTimeout)
            onComplete()
        }, { once: true })

        audio.currentTime = 0
        
        // More robust play attempt for iPad Safari
        const playPromise = audio.play()
        if (playPromise !== undefined) {
            playPromise
                .then(() => {
                    console.log('Audio notification playing successfully')
                })
                .catch(error => {
                    console.log('Audio play failed:', error)
                    // If audio fails, try to unlock again (mobile browsers may suspend context)
                    if (isIPadSafari) {
                        console.log('Attempting iPad Safari audio recovery')
                        performAudioUnlock()
                        // Try once more after unlock
                        setTimeout(() => {
                            audio.play().catch(() => {
                                console.log('iPad Safari audio recovery failed')
                            })
                        }, 200)
                    }
                    clearTimeout(playbackTimeout)
                    onComplete()
                })
        } else {
            // Old browser - assume it worked
            setTimeout(onComplete, 2000)
        }
    }).catch(error => {
        // AudioContext resume failed, skip this notification
        console.log('AudioContext preparation failed:', error)
        isPlayingNotification = true
        pendingNotificationCount -= 1
        playNextNotification()
    })
}

// Check if audio overlay should be shown
export function shouldShowAudioOverlay() {
    const audioEnabled = localStorage.getItem('audioEnabled')
    return audioEnabled !== 'true'
}

// Check if playSoundPermission feature flag is active
export function isPlaySoundPermissionActive(overlaysConfig, currentStoreId = null) {
    if (!overlaysConfig || !Array.isArray(overlaysConfig)) {
        return false
    }
    
    const playSoundPermission = overlaysConfig.find(property => property.id === 'playSoundPermission')
    
    // First check: playSoundPermission must exist
    if (!playSoundPermission) {
        return false
    }
    
    // Second check: is_active must be true
    if (playSoundPermission.is_active !== true) {
        return false
    }
    
    // Third check: if store_id array exists, current store must be in the array
    if (playSoundPermission.store_id && Array.isArray(playSoundPermission.store_id)) {
        if (!currentStoreId) {
            return false
        }
        
        // Store ID must be in the allowed array
        return playSoundPermission.store_id.includes(currentStoreId)
    }
    
    // If no store_id array specified, feature is active for all stores
    return true
}

// Enqueues a notification sound for playback with basic throttling.
export function playNotificationSound(orderId = 'unknown') {
    // Import AppAnalytics and AppData for tracking
    const AppAnalytics = require('./AppAnalytics').default
    const AppData = require('./AppData').default
    
    // Cleanup old ignored sound IDs before checking (on-demand cleanup)
    cleanupOldIgnoredSounds(AppData)
    
    // Check if user has enabled audio via overlay
    const audioEnabled = localStorage.getItem('audioEnabled')
    if (audioEnabled !== 'true') {
        // Audio not enabled via overlay, skip playing sound
        AppAnalytics.trackAction('sound_not_played', {
            orderId: orderId,
            reason: 'audio_not_enabled'
        })
        return
    }

    // Check if sound should play using AppData logic and track analytics here
    if (!AppData.shouldSoundPlay(orderId)) {
        // Determine the reason for blocking
        let reason = 'unknown'
        if (AppData.ignoredSoundIds.includes(orderId)) {
            reason = 'ignored_sound_id'
        } else if (AppData.isPlaying === true && orderId !== AppData.playingOrderId) {
            reason = 'already_playing'
        }
        
        AppAnalytics.trackAction('sound_blocked', {
            orderId: orderId,
            reason: reason
        })
        return
    }

    // Sound is allowed to play - track it
    AppAnalytics.trackAction('sound_allowed', {
        orderId: orderId
    })

    // Set playing state to prevent duplicate sounds for the same order
    AppData.isPlaying = true
    AppData.playingOrderId = orderId
    
    // Add to ignored list to prevent this order from playing sound again
    AppData.ignoredSoundIds.push(orderId)
    
    // Record timestamp for cleanup (will be removed after 1 hour)
    ignoredSoundTimestamps[orderId] = Date.now()

    // Always try to unlock audio first
    if (!audioUnlocked) {
        unlockAudio()
    }

    // Throttle rapid calls so the same event does not enqueue multiple sounds.
    const now = Date.now()
    if (now - lastNotificationEnqueueTime < 200) {
        AppAnalytics.trackAction('sound_not_played', {
            orderId: orderId,
            reason: 'throttled'
        })
        return
    }
    lastNotificationEnqueueTime = now

    // Track successful sound play
    AppAnalytics.trackAction('sound_played', {
        orderId: orderId
    })

    pendingNotificationCount += 1

    if (!isPlayingNotification) {
        playNextNotification()
    }
}
